const e = {
  login: {
    schema: {
      method: "post",
      url: "/auth/login",
      mediaType: "application/json"
    }
  },
  refresh: {
    schema: {
      method: "post",
      url: "/auth/refresh",
      mediaType: "application/json"
    }
  },
  logout: {
    schema: {
      method: "post",
      url: "/auth/logout",
      mediaType: "application/json"
    }
  },
  passwordRequest: {
    schema: {
      method: "post",
      url: "/auth/password/request",
      mediaType: "application/json"
    }
  },
  passwordReset: {
    schema: {
      method: "post",
      url: "/auth/password/reset",
      mediaType: "application/json"
    }
  },
  oauth: {
    schema: {
      method: "get",
      url: "/auth/oauth"
    }
  },
  oauthProvider: {
    schema: {
      method: "get",
      url: "/auth/oauth/{provider}"
    }
  }
};
export {
  e as authService
};
